import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneDeparture, faPlaneArrival } from "@fortawesome/free-solid-svg-icons";
import { formatTime } from "../../utils/formatDateHeure";

const FormAirport = ({ trajet, type, reservationData, handleChange, fieldRefs, getMinMaxTime}) => {
    const isPickup = type === "pu"; // Vérifie si c'est un Départ (from : lieu de prise en charge)
    const sectionTitle = isPickup ? "Arrival Airport" : "Departure Airport";
    const sectionHeader = isPickup ? reservationData[`lieu_pu_${trajet}`] : reservationData[`lieu_drop_${trajet}`];
    const icon = isPickup ? faPlaneArrival : faPlaneDeparture;

    const { minH, minM, maxH, maxM } = getMinMaxTime(type, reservationData);
    

    return (
        <div className="form-section airport-section m-0 p-2">
            <div className="section-header">{sectionHeader}</div>
            <h3><FontAwesomeIcon icon={icon} /> &nbsp;{sectionTitle}</h3>

            <label>
                {isPickup ? "Landing Time" : "Flight Take Off time"} 
                <small style={{ marginLeft: "8px", color: "#666" }}>
                    (Time must be in 15-minute intervals)
                </small>
                {/* Time: trajet={trajet} type={type}
                <br />type_pu_={reservationData[`type_pu_${trajet}`]}
                <br />type_drop_={reservationData[`type_drop_${trajet}`]} */}
                <input
                    ref={fieldRefs[`horaire_vol_${type}_${trajet}`]}
                    type="time"
                    id={`horaire_vol_${type}_${trajet}`}
                    value={reservationData[`horaire_vol_${type}_${trajet}`] || ""}
                    onChange={handleChange}
                    required
                    min={formatTime(minH, minM)}
                    max={formatTime(maxH, maxM)}
                    step="900" // 900 secondes : 15 minutes
                />

            </label>

            <label>
                {isPickup ? "City of Origin" : "Destination City"}:
                <input
                    ref={fieldRefs[`city_vol_${type}_${trajet}`]}
                    type="text"
                    id={`city_vol_${type}_${trajet}`}
                    value={reservationData[`city_vol_${type}_${trajet}`] || ""}
                    onChange={handleChange}
                    placeholder={isPickup ? "Enter city of origin" : "Enter destination city"}
                    required
                    />
            </label>

            <label>
                Flight Number:
                <input
                    ref={fieldRefs[`num_vol_${type}_${trajet}`]}
                    type="text"
                    id={`num_vol_${type}_${trajet}`}
                    value={reservationData[`num_vol_${type}_${trajet}`] || ""}
                    onChange={handleChange}
                    placeholder="Enter flight number"
                    required
                />
            </label>
        </div>
    );
};

export default FormAirport;
